const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgCheckIdBioSenseLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    viewBox: "0 0 1667 417",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h400v100H0z",
    style: {
      fill: "none"
    },
    transform: "scale(4.16667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 .034.259-.259a.384.384 0 0 0 .482.001L1 .035a.75.75 0 0 1-1-.001",
    style: {
      fill: "url(#a)",
      fillRule: "nonzero"
    },
    transform: "matrix(134.84396 0 0 -134.84396 364.416 137.137)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0-.032.135-.135a.54.54 0 0 0 .73 0L1-.031a.73.73 0 0 1-1-.001",
    style: {
      fill: "url(#b)",
      fillRule: "nonzero"
    },
    transform: "matrix(257.21515 0 0 -257.21515 303.246 63.247)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.5.024a.54.54 0 0 0-.365.142L0 .031a.726.726 0 0 1 1 .001L.865.167A.54.54 0 0 0 .5.024",
    style: {
      fill: "url(#c)",
      fillRule: "nonzero"
    },
    transform: "matrix(257.56646 0 0 -257.56646 303.245 353.308)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.499.139a.4.4 0 0 0-.241.085L0-.035a.75.75 0 0 1 1 .002L.742.225A.4.4 0 0 0 .499.139",
    style: {
      fill: "url(#d)",
      fillRule: "nonzero"
    },
    transform: "matrix(135.20698 0 0 -135.20698 364.416 279.425)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-4.469-4.469a4.47 4.47 0 1 0 0 8.938 4.47 4.47 0 0 0 0-8.938",
    style: {
      fill: "#ff931e",
      fillRule: "nonzero"
    },
    transform: "matrix(0 -4.16667 -4.16667 0 431.84 189.713)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c0-8.703 3.338-16.624 8.799-22.561L.483-30.877c-7.295 7.76-11.876 18.089-12.227 29.47v2.814c.351 11.381 4.932 21.71 12.227 29.47l8.316-8.316C3.338 16.624 0 8.703 0 0",
    style: {
      fill: "#ff931e",
      fillRule: "nonzero"
    },
    transform: "translate(292.94 208.333)scale(4.16667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 .097v-.194c.022-.39.178-.744.423-1.018L1-.538a.9.9 0 0 0-.149.281v.001a1 1 0 0 0-.028.122l-.001.007-.005.03v.008a1 1 0 0 0 0 .178v.008l.005.03.001.007A.858.858 0 0 0 1 .538l-.577.577A1.66 1.66 0 0 1 0 .097",
    style: {
      fill: "url(#e)",
      fillRule: "nonzero"
    },
    transform: "matrix(60.49644 0 0 -60.49644 330.551 208.333)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.177.353A.24.24 0 0 1 .073.305.2.2 0 0 1 .017.22.4.4 0 0 1 0 .096v-.193a.4.4 0 0 1 .017-.124.2.2 0 0 1 .056-.085.25.25 0 0 1 .104-.048 1 1 0 0 1 .161-.014H1v.161H.358q-.093 0-.124.028a.11.11 0 0 0-.032.091v.032h.717a.1.1 0 0 1 .061.017.08.08 0 0 1 .02.06v.127a.4.4 0 0 1-.012.103.14.14 0 0 1-.039.069.15.15 0 0 1-.075.037.5.5 0 0 1-.12.012H.325Q.249.369.177.353M.202.1a.11.11 0 0 0 .032.092Q.265.22.358.22h.356A.1.1 0 0 0 .782.202.08.08 0 0 0 .801.143V.087q0-.023-.024-.023H.202z",
    style: {
      fill: "url(#f)",
      fillRule: "nonzero"
    },
    transform: "matrix(167.61376 0 0 -167.61376 691.871 208.363)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.087.367A.26.26 0 0 1 0 .165v-.327a.26.26 0 0 1 .087-.202.3.3 0 0 1 .21-.08H1v.208H.297q-.085 0-.085.074v.327q0 .074.085.074H1v.209H.29A.3.3 0 0 1 .087.367",
    style: {
      fill: "url(#g)",
      fillRule: "nonzero"
    },
    transform: "matrix(136.99387 0 0 -136.99387 873.777 208.563)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.699.385.342.094v-.17l.386-.309H1l-.429.384.399.386zM0-.385h.199v.77H0z",
    style: {
      fill: "url(#h)",
      fillRule: "nonzero"
    },
    transform: "matrix(160.34396 0 0 -160.34396 1030.383 208.333)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.205 35.174h7.773v29.653h-7.773z",
    style: {
      fill: "#ff931e"
    },
    transform: "translate(0 -.004)scale(4.16667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 10.939a8.47 8.47 0 0 1-3.174 6.735 11.58 11.58 0 0 1-7.75 2.69h-25.965V1.59h7.849v11.824h18.173q3.016 0 3.017-2.484V.015q0-2.483-3.015-2.483h-26.03v-6.957h25.972a11.58 11.58 0 0 1 7.75 2.689A8.48 8.48 0 0 1-.001.003z",
    style: {
      fill: "#ff931e",
      fillRule: "nonzero"
    },
    transform: "translate(1422.656 185.545)scale(4.16667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.78.419V.095H.22v.324H0v-.838h.22v.324h.56v-.324H1v.838z",
    style: {
      fill: "url(#i)",
      fillRule: "nonzero"
    },
    transform: "matrix(147.46427 0 0 -147.46427 525.08 208.33)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565.991 430.623h16.944q7.087 0 10.437 2.77 3.415 2.835 3.415 8.569 0 7.344-5.734 9.471v.128q7.216 2.192 7.216 10.824 0 6.185-3.479 9.149-3.415 2.963-10.695 2.963h-18.233zm16.493 18.748q4.51 0 6.572-1.546 1.997-1.547 1.997-5.154 0-3.673-1.997-5.219-2.062-1.546-6.572-1.546h-10.695v13.529zm.773 19.843q4.897 0 7.023-1.739t2.126-5.541q0-3.93-2.255-5.605t-7.538-1.675h-10.888v14.431zM632.866 430.687h5.798v43.81h-5.798zM691.429 475.27q-17.009 0-17.009-17.459v-10.437q0-17.46 17.009-17.46t17.009 17.46v10.437q0 17.459-17.009 17.459m0-5.283q5.798 0 8.504-2.963t2.706-9.278v-10.437q0-6.249-2.706-9.277-2.706-2.964-8.504-2.964t-8.504 2.964q-2.706 3.028-2.706 9.277v10.437q0 6.315 2.706 9.278t8.504 2.963M756.499 475.657q-15.784 0-15.784-13.208h5.798q0 7.925 10.051 7.925 9.6 0 9.599-7.023 0-3.543-2.448-5.411-2.383-1.805-8.44-2.706-7.473-1.03-10.63-3.866-3.157-2.77-3.157-8.504 0-6.25 3.866-9.535t11.339-3.286q14.56 0 14.56 12.821h-5.798q0-7.538-8.956-7.538-4.445 0-6.829 1.74t-2.383 5.089q0 3.286 2.319 5.025c1.503 1.117 7.86 2.384 7.86 2.384s6.915 1.332 9.02 2.448q3.027 1.611 4.316 4.188t1.289 6.249q0 12.822-15.398 12.821zM806.237 430.687h28.669v5.283h-22.871v13.465h19.65v5.283h-19.65v14.496h23.515v5.283h-29.313zM869.568 430.687h6.893l20.166 33.309v-33.309h5.605v43.81h-5.67l-21.389-35.305v35.305h-5.605zM951.84 475.657q-15.785 0-15.785-13.208h5.799q0 7.925 10.05 7.925 9.6 0 9.6-7.023 0-3.543-2.448-5.411-2.385-1.805-8.44-2.706-7.474-1.03-10.631-3.866-3.157-2.77-3.157-8.504 0-6.25 3.866-9.535t11.339-3.286q14.56 0 14.56 12.821h-5.798q0-7.538-8.955-7.538-4.446 0-6.829 1.74-2.385 1.739-2.384 5.089 0 3.286 2.319 5.025 2.255 1.676 7.86 2.384 5.863.774 9.02 2.448 3.028 1.611 4.316 4.188 1.289 2.577 1.289 6.249 0 12.822-15.398 12.821zM1001.577 430.687h28.67v5.283h-22.872v13.465h19.65v5.283h-19.65v14.496h23.516v5.283h-29.314z",
    style: {
      fill: "#4d4d4d"
    },
    transform: "matrix(1.05118 0 0 1.16412 77.726 -177.22)"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1c56c9",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    style: {
      stopColor: "#1a3163",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1a3163",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1c56c9",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    style: {
      stopColor: "#1a3163",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1a3163",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1c56c9",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    style: {
      stopColor: "#1a3163",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1a3163",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1c56c9",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    style: {
      stopColor: "#1a3163",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1a3163",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1c56c9",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    style: {
      stopColor: "#1a3163",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1a3163",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1c56c9",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    style: {
      stopColor: "#1a3163",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1a3163",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "matrix(1 0 0 -1 0 .002)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1c56c9",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    style: {
      stopColor: "#1a3163",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1a3163",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1c56c9",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    style: {
      stopColor: "#1a3163",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1a3163",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1c56c9",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    style: {
      stopColor: "#1a3163",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1a3163",
      stopOpacity: 1
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIdBioSenseLight);
export default __webpack_public_path__ + "static/media/CheckIDBioSense_light.741edc877ec77d2c66270990e12ce857.svg";
export { ForwardRef as ReactComponent };